
import { Component, Vue } from "vue-property-decorator";

interface dataButton {
  id: number | any;
  titulo?: string;
  subtitulo?: string;
  uri?: string;
  color?: string;
  img?: string;
  subMenu?: Array<dataButton>;
}

@Component
export default class FooterWeb extends Vue {
  private buttonsNetworks: Array<dataButton> = [
    {
      id: 1,
      img: require("../../../assets/Web/Insta-blanco.png"),
      uri: "https://www.instagram.com/muni_maipu/"
    },
    {
      id: 2,
      img: require("../../../assets/Web/Face-blanco.png"),
      uri: "https://www.facebook.com/munimaipu/"
    },
    {
      id: 3,
      img: require("../../../assets/Web/x-blanco.png"),
      uri: "https://x.com/muni_maipu"
    },
    {
      id: 4,
      img: require("../../../assets/Web/Youtube-blanco.png"),
      uri: "https://www.youtube.com/channel/UCNHAaMlDOY3TXBr_3kNHV5A"
    },
    {
      id: 5,
      img: require("../../../assets/Web/in-blanco.png"),
      uri: "https://cl.linkedin.com/company/municipalidad-maipu"
    },
    {
      id: 6,
      img: require("../../../assets/Web/Tiktok-blanco.svg"),
      uri: "https://www.tiktok.com/@muni_maipu"
    },
    {
      id: 7,
      img: require("../../../assets/Web/wsp-blanco.png"),
      uri:
        "https://www.municipalidadmaipu.cl/noticias/publicacion/592/grupos-difusion-whatsapp"
    }
  ];
  private win = window;
  private routerGo(name: string) {
    if (name && name != "") {
      if (this.$router.currentRoute.name == name) {
        this.$router.go(0);
      } else {
        this.$router.push({ name: name }).catch(err => {
          console.log(err);
        });
      }
    }
  }
}
